export function dailyCounts(items, { days = 7, dateField = "createdAt" } = {}) {
  const buckets = new Array(days).fill(0);
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  items.forEach((item) => {
    const raw = item?.[dateField];
    if (!raw) return;
    const date = new Date(raw);
    const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const diffDays = Math.round((startOfToday - dayStart) / 86400000);
    if (diffDays >= 0 && diffDays < days) buckets[days - 1 - diffDays] += 1;
  });

  return buckets;
}

export function countSince(items, { days = 7, dateField = "createdAt" } = {}) {
  const cutoff = Date.now() - days * 86400000;
  return items.filter((item) => item?.[dateField] && new Date(item[dateField]).getTime() >= cutoff).length;
}

export function upcomingCounts(items, { days = 7, dateField = "startsAt" } = {}) {
  const buckets = new Array(days).fill(0);
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  items.forEach((item) => {
    const raw = item?.[dateField];
    if (!raw) return;
    const date = new Date(raw);
    const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const diffDays = Math.round((dayStart - startOfToday) / 86400000);
    if (diffDays >= 0 && diffDays < days) buckets[diffDays] += 1;
  });

  return buckets;
}
